import React, { Component } from "react";
import withStyles from '@mui/styles/withStyles';

import { Colors } from "config/StyleConfig";
import TextField from "@mui/material/TextField";

const styles = () => ({
  root: {
    "& .MuiInputBase-root.Mui-disabled": {
      color: Colors.text,
    },
  },
});

class LabeledText extends Component {
  render() {
    const { classes } = this.props;

    return (
      <TextField
        className={classes.root}
        disabled
        variant="standard"
        InputProps={{ disableUnderline: true }}
        {...this.props}
      />
    );
  }
}

export default withStyles(styles)(LabeledText);
